export default "__VITE_ASSET__0Tbcw371__"